module.exports = __webpack_public_path__ + "img/top.dfa0a83f.png";